module.exports = __webpack_public_path__ + "img/SaasManagerLogo.d6889fad.svg";